module.exports = __webpack_public_path__ + "img/749DCBE9905D3856.167d5c66.png";